import omit from "lodash/omit";
import { areFiltersEqual } from "PFCore/helpers/filters";
import { FiltersMetaV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";

import { SavedFiltersProps } from "../filters_v2_panel";

export const isSavedFiltersCollectionSelected = (
  { mainFilters, childrenFilters }: FiltersMetaV2<FilterV2WithValueOnly>,
  collection?: FiltersMetaV2<FilterV2WithValueOnly>,
  excludedFilters?: SavedFiltersProps["omit"]
) => {
  const mainFiltersFinal = omit(
    mainFilters,
    excludedFilters?.main || []
  ) as FiltersMetaV2<FilterV2WithValueOnly>["mainFilters"];
  const childrenFiltersFinal = omit(
    childrenFilters || {},
    excludedFilters?.children || []
  ) as FiltersMetaV2<FilterV2WithValueOnly>["childrenFilters"];

  const collectionMainFiltersFinal = omit(
    collection?.mainFilters || {},
    excludedFilters?.main || []
  ) as FiltersMetaV2<FilterV2WithValueOnly>["mainFilters"];
  const collectionChildrenFiltersFinal = omit(
    collection?.childrenFilters || {},
    excludedFilters?.children || []
  ) as FiltersMetaV2<FilterV2WithValueOnly>["childrenFilters"];

  return (
    areFiltersEqual(mainFiltersFinal, collectionMainFiltersFinal) &&
    areFiltersEqual(childrenFiltersFinal || {}, collectionChildrenFiltersFinal || {})
  );
};
